import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface DepartmentTab {
  id: string;
  label: string;
}

interface FactItem {
  title: string;
  value: string;
}

interface ReportEvent {
  title: string;
  date: string;
  description: string;
  image: string;
  highlight?: string;
}

interface IntramuralEvent {
  sno: number;
  title: string;
  category: string;
  dates: string;
  participants: string;
  winner: string;
  runnerUp: string;
  description: string;
  image: string;
}

interface AchievementItem {
  studentName: string;
  department: string;
  year: string;
  event: string;
  achievement: string;
  description: string;
  image: string;
}

@Component({
  selector: 'app-shop-full-width-page',
  templateUrl: './shop-full-width-page.component.html',
  styleUrls: ['./shop-full-width-page.component.scss']
})
export class ShopFullWidthPageComponent implements OnInit {
  isToggled = false;
  selectedTab = 'tab1';

  institutionName = 'FATIMA MICHAEL COLLEGE OF ENGINEERING AND TECHNOLOGY';
  campusLine = 'MADURAI - 20';
  departmentName = 'DEPARTMENT OF PHYSICAL EDUCATION';
  academicYear = '2025 - 2026';

  icclDepartments = '9 Departments';
  intramuralDepartments = '7 Departments';
  athleticsParticipation = '125 Students';

  sportsNotice =
    'Annual sports activities, intramural tournaments, staff matches, student achievements, and Lions Cricket League highlights for the academic year 2025 - 2026.';

  overviewImage = 'assets/img/sports/e3.jpeg';

  tabs: DepartmentTab[] = [
    { id: 'tab1', label: 'Overview' },
    { id: 'tab2', label: 'Major Events' },
    { id: 'tab3', label: 'Intramural Sports' },
    { id: 'tab4', label: 'Staff Events' },
    { id: 'tab5', label: 'Student Achievements' },
    { id: 'tab6', label: 'Lions Cricket League' }
  ];

  reportOverviewParagraphs: string[] = [
    'The Department of Physical Education actively organized a range of sports events and competitions during the academic year 2025 - 2026, creating a vibrant atmosphere of participation, discipline, teamwork, and healthy competition on campus.',
    'Major events included the Michael Premier Cricket League, Intramural College Cricket League, a series of interdepartmental intramural tournaments, staff sports events, and a special Lions Cricket League hosted at the FMCET cricket ground.',
    'Students from multiple departments participated enthusiastically in cricket, badminton, volleyball, kabaddi, throwball, athletics, and indoor games. The department also celebrated outstanding individual achievements of students in bodybuilding, weightlifting, and Silambam.',
    'Through these sporting engagements, the institution strengthened physical fitness, leadership qualities, team spirit, and sportsmanship among students and staff while promoting the overall culture of excellence in co-curricular development.'
  ];

  reportStats: FactItem[] = [
    {
      title: 'Academic Year',
      value: '2025 - 2026'
    },
    {
      title: 'ICCL Participation',
      value: '9 Departments'
    },
    {
      title: 'Intramural Participation',
      value: '7 Departments'
    },
    {
      title: 'Athletics Participation',
      value: '125 Students'
    }
  ];

  reportHighlights: string[] = [
    'Michael Premier Cricket League (MPCL) successfully brought together school teams in a competitive sports environment.',
    'Intramural College Cricket League (ICCL) featured participation from nine departments and strengthened interdepartmental bonding.',
    'Intramural tournaments in volleyball, kabaddi, badminton, throwball, carrom, and athletics created active student engagement across campus.',
    'Staff cricket and women’s throwball matches encouraged recreational participation and team spirit among faculty members.',
    'Students earned notable recognition in bodybuilding, weightlifting, and Silambam at external competitive events.',
    'Lions Cricket League 2026 added distinction to the annual sports calendar with special guests and prize distribution.'
  ];

  majorEvents: ReportEvent[] = [
    {
      title: 'Michael Premier Cricket League (MPCL) Tournament',
      date: '08 - 10 Aug 2025',
      image: 'assets/img/sports/e1.jpeg',
      description:
        'The Michael Premier Cricket League (MPCL) was conducted at FMCET, Madurai. The tournament brought together school teams in a competitive and spirited environment. The event was organized successfully with strong participation and enthusiastic support.',
      highlight:
        'St. Michael School, Sivagangai won the tournament, while MM School, Thirunagar finished as runner-up. Cash awards were presented by our CEO and Principal.'
    },
    {
      title: 'Intramural College Cricket League (ICCL) Tournament',
      date: '09 - 11 Feb 2026',
      image: 'assets/img/sports/e2.jpeg',
      description:
        'The Intramural College Cricket League was organized by Fatima Michael College of Engineering and Technology, Madurai. Nine departments participated and displayed impressive cricketing skills, teamwork, and sporting spirit. The event served as an excellent platform for students to showcase talent and strengthen interdepartmental bonding.',
      highlight:
        'AIML department won the ICCL cricket tournament and ECE department emerged as runner-up. Awards were presented by our CEO Madam and Principal Sir.'
    },
    {
      title: 'Intramural Tournaments',
      date: '02 - 10 Mar 2026',
      image: 'assets/img/sports/e3.jpeg',
      description:
        'The Department of Physical Education organized a series of intramural tournaments covering Volleyball, Kabaddi, Badminton, Throwball, Carrom, and Athletics. Seven departments actively participated across multiple events, creating a vibrant sporting atmosphere throughout the campus.',
      highlight:
        'Prizes were distributed by the Chairman, CEO, Principal, and special guest Actor Madurai Muthu.'
    }
  ];

  intramuralEvents: IntramuralEvent[] = [
    {
      sno: 1,
      title: 'Badminton (Boys)',
      category: 'Intramural Tournament',
      dates: '02 - 03 Mar 2026',
      participants: '7 Departments',
      winner: 'CSE',
      runnerUp: 'Mech & Auto',
      image: 'assets/img/sports/e4.jpeg',
      description:
        'The badminton tournament for boys featured thrilling matches and strong sportsmanship. CSE emerged as champions after an impressive performance throughout the competition.'
    },
    {
      sno: 2,
      title: 'Kabaddi (Boys)',
      category: 'Intramural Tournament',
      dates: '04 - 05 Mar 2026',
      participants: '7 Departments',
      winner: 'Civil',
      runnerUp: 'AIML',
      image: 'assets/img/sports/e5.jpeg',
      description:
        'The kabaddi competition showcased strength, strategy, and teamwork. Civil department secured the championship title with AIML finishing as runner-up.'
    },
    {
      sno: 3,
      title: 'Carrom (Girls)',
      category: 'Intramural Tournament',
      dates: '02 - 03 Mar 2026',
      participants: '7 Departments',
      winner: 'CSE AIML',
      runnerUp: 'CSE Cyber Security',
      image: 'assets/img/sports/e6.jpeg',
      description:
        'The girls carrom tournament highlighted focus, precision, and excellent gameplay. AIML department clinched the title and CS department secured second place.'
    },
    {
      sno: 4,
      title: 'Volleyball (Boys)',
      category: 'Intramural Tournament',
      dates: '02 - 03 Mar 2026',
      participants: '7 Departments',
      winner: 'CSE',
      runnerUp: 'AIML',
      image: 'assets/img/sports/e7.jpeg',
      description:
        'The volleyball tournament produced energetic matches and strong team coordination. CSE department claimed the championship and AIML took the runner-up spot.'
    },
    {
      sno: 5,
      title: 'Throwball (Girls)',
      category: 'Intramural Tournament',
      dates: '04 - 05 Mar 2026',
      participants: '7 Departments',
      winner: 'CSE Cyber Scurity',
      runnerUp: 'ECE',
      image: 'assets/img/sports/e8.jpeg',
      description:
        'The girls throwball tournament displayed athletic ability, energy, and teamwork. CS department won the championship while ECE department finished as runner-up.'
    },
    {
      sno: 6,
      title: 'Badminton (Girls)',
      category: 'Intramural Tournament',
      dates: '06 & 09 Mar 2026',
      participants: '7 Departments',
      winner: 'CSE Cyber Security',
      runnerUp: 'ECE',
      image: 'assets/img/sports/e9.jpeg',
      description:
        'The girls badminton tournament featured exciting and competitive matches. CS department emerged as champions and ECE department secured the runner-up position.'
    },
    {
      sno: 7,
      title: 'Athletics - Shot Put / 100m / 200m',
      category: 'Athletics Meet',
      dates: '09 Mar 2026',
      participants: '125 Students from 7 Departments',
      winner: 'Event-wise winners',
      runnerUp: 'Event-wise runners-up',
      image: 'assets/img/sports/e10.jpeg',
      description:
        'FMCET hosted an athletics meet for boys and girls at the college ground. Events included 100m, 200m, and shot put competitions, showcasing student speed, agility, strength, and enthusiasm.'
    }
  ];

  staffEvents: ReportEvent[] = [
    {
      title: 'Staff Cricket Match',
      date: '07 Mar 2026',
      image: 'assets/img/sports/e11.jpeg',
      description:
        'A staff cricket tournament was successfully organized to promote camaraderie and healthy competition among staff members. The event was appreciated for its team spirit and lively participation.'
    },
    {
      title: 'Staff Throwball Match - Women',
      date: '07 Mar 2026',
      image: 'assets/img/sports/e12.jpeg',
      description:
        'A women’s staff throwball tournament was organized in the college, with active and energetic participation from female staff members. The event reflected teamwork, coordination, and enthusiasm.'
    }
  ];

  studentAchievements: AchievementItem[] = [
    {
      studentName: 'Mr. Kaviyarasu A',
      department: 'ECE',
      year: 'III Year',
      event: 'MR South India 2026 Bodybuilding Event',
      achievement: 'Secured 9th Place',
      image: 'assets/img/sports/e13.jpeg',
      description:
        'His achievement in the bodybuilding event organized by the Indian Federation reflects dedication, discipline, and hard work in the field of fitness and sports.'
    },
    {
      studentName: 'Mr. C. Ramanathan',
      department: 'EEE',
      year: 'III Year',
      event: 'CM Trophy - Weightlifting',
      achievement: 'Won Third Place and qualified for State Level',
      image: 'assets/img/sports/e14.jpeg',
      description:
        'This remarkable performance highlights his exceptional strength, commitment, and competitive excellence in weightlifting.'
    },
    {
      studentName: 'Mr. K. Yuvaraj',
      department: 'CSE',
      year: 'III Year',
      event: 'CM Trophy - Silambam',
      achievement: 'Won Gold Medal and qualified for State Level',
      image: 'assets/img/sports/e15.jpeg',
      description:
        'His outstanding success in Silambam demonstrates exceptional talent in traditional martial arts and brings pride to the institution.'
    }
  ];

  lionsCricketLeague: ReportEvent = {
    title: 'Lions Cricket League 2026',
    date: '13 - 14 Mar 2026',
    image: 'assets/img/sports/e16.jpeg',
    description:
      'The Lions Cricket League 2026, hosted by Lions International District 3242 B (2025 - 26), was conducted at the FMCET Cricket Ground, Poovanthi, Madurai. The event featured exciting cricketing performances and created a memorable experience for participants and attendees.',
    highlight:
      'The tournament was inaugurated by PMJF Lion P. Ayyadurai, Multiple Council Chairperson, District MD 3242, who also presented the winner and runner-up awards.'
  };

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'Sports Report';
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  ngOnInit(): void {}
}